import { Unsubscribe } from "../types/Unsubscribe";

/** Create a disposal function with an add function to register multiple unsubscribes to dispose. */
export const createDispose = () => {
  const unsubscribes: Unsubscribe[] = [];

  /** Unsubscribe from all registered subscriptions. */
  const dispose = () => {
    while (unsubscribes.length > 0) {
      const unsubscribe = unsubscribes.pop()!;
      unsubscribe();
    }
  };

  /** Register an unsubscribe callback to be executed on disposal. */
  dispose.add = (unsubscribe: Unsubscribe) => {
    unsubscribes.push(unsubscribe);
  };

  /** Get the current number of unsubscribes registered. */
  dispose.getCount = () => unsubscribes.length;

  return dispose;
};
